var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.572 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 601"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.38 3.409a2.85 2.85 0 0 1-2.781 2.045 2.731 2.731 0 1 1 0-5.455A2.85 2.85 0 0 1 8.38 2.044h19.473a.683.683 0 1 1 0 1.364Zm-1.345-.682a1.438 1.438 0 1 1-1.436-1.364 1.4 1.4 0 0 1 1.435 1.364Z",
    "data-name": "Path 201"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.682 3.409h2.131a2.75 2.75 0 0 1 0-1.364H.682a.682.682 0 0 0 0 1.364",
    "data-name": "Path 202"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.053 16.59a2.894 2.894 0 0 0-5.534 0H.714a.683.683 0 1 0 0 1.364h10.8a2.894 2.894 0 0 0 5.534 0h10.8a.683.683 0 1 0 0-1.364Zm-2.767 2.045a1.365 1.365 0 1 0-1.429-1.364 1.4 1.4 0 0 0 1.429 1.365Z",
    "data-name": "Path 203"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 604"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M25.624 9.318a2.894 2.894 0 0 0-5.534 0H.714a.683.683 0 1 0 0 1.364H20.09a2.894 2.894 0 0 0 5.534 0h2.233a.683.683 0 1 0 0-1.364Zm-2.767 2.045a1.365 1.365 0 1 0-1.429-1.364 1.4 1.4 0 0 0 1.429 1.364",
    "data-name": "Path 204"
  }))));
};
export default SvgFilter;